import ConvertUnits from 'convert-units'
import { get, round, toNumber } from 'lodash'

/**
 * Shared component used for computing distance and labels for locations. This
 * component expects to be mixed in with the CurrentUserMixin (failing to do so
 * will result in errors when accessing the customerContext property below).
 */
const LocationUtilitiesMixin = {
  methods: {
    /**
     * Ensures the value is converted to metric. Only applies to customers with
     * imperial units of measure
     *
     * @param float value
     * @param int precision
     * @return float
     */
    metricDistance (value, precision = 0) {
      let metricDistance = 0

      if (this.customerContext.getSetting('distanceFormat') === 'imperial') {
        metricDistance = round(ConvertUnits(value).from('ft').to('m'), precision)
      } else {
        metricDistance = round(value, precision)
      }

      return toNumber(metricDistance.toFixed(precision))
    },

    /**
     * localize the distance based on the distanceFormat customer setting
     * (converting units from metric to imperial if appropriate)
     *
     * @param float value
     * @param int precision
     * @return float
     */
    customerDistance (value, precision = 0) {
      // Return early if the value we got isn't parseable as a number
      if (value == null) {
        return value
      }

      let customerDistance = 0

      if (this.customerContext.getSetting('distanceFormat') === 'imperial') {
        customerDistance = round(ConvertUnits(value).from('m').to('ft'), precision)
      } else {
        customerDistance = round(value, precision)
      }

      return toNumber(customerDistance.toFixed(precision))
    }
  },
  computed: {
    /**
     *
     */
    customerDefaultRadius () {
      return get(this.customerContext.getSetting('processing.GpsLocationState'), 'radius')
    },

    /**
     * Returns the appropriate scale unit of measure based on the customer's
     * distanceFormat setting (e.g. 'foot' or 'meter')
     *
     * @return string
     */
    radiusUnitOfMeasure () {
      return this.customerContext.getSetting('distanceFormat') === 'imperial' ? 'foot' : 'meter'
    }
  }
}

export default LocationUtilitiesMixin
